export const mandatoryFields = [
	{label: "CSV", value: "CSV"},
	{label: "Word", value: "Word"},
	{label: "Excel", value: "Excel"},
	{label: "PDF", value: "PDF"},
]

// --- Report Button Dropdown links ---
export const BUTTON_LINKS = [
	{
		id: "oncall",
		text: "Accounting Central On-Call",
		href: "https://t.corp.amazon.com/create/templates/9c41d7b9-b693-433e-950a-ec29fcfce9f5",
		external: true,
		externalIconAriaLabel: "(opens in new tab)",
	},
	{
		id: "workiva",
		text: "Workiva On-Call",
		href: "https://t.corp.amazon.com/create/templates/de37966e-6798-4dcf-be9f-0d4f15657208",
		external: true,
		externalIconAriaLabel: "(opens in new tab)",
	},
	{
		id: "change",
		text: "Request a Leadsheet Change",
		href: "https://t.corp.amazon.com/create/templates/d96c65b1-0159-4c24-9273-34cc484a51a8",
		external: true,
		externalIconAriaLabel: "(opens in new tab)",
	},
];

// --- Alert text and links ---
export const LEAD_SHEET_NOTICE =
	"Ensure you are using the latest Lead Sheet version before proceeding. Outdated templates may be rejected.";

export const LEAD_SHEET_TEMPLATES_URL =
	"https://amazon.awsapps.com/workdocs-amazon/index.html#/folder/61c83463354637917b06437e4beff89e5ff7ff264a10ccfe6f4f39b3adffed31";

export const NEW_TO_CORP_REPORTING =
	"New to SEC Central? You can find guidance here:";

export const CORP_REPORTING_GUIDE_URL =
	"https://wiki.amazon.com/bin/view/Sec-Reporting";
